import React from "react";
import key_car_checklist from "../../../../assets/images/keyless-return/car_checklist.svg";
import key_error from "../../../../assets/images/keyless-return/error.svg";
import "./checklist.css";

export default function Checklist({ checklistChecks, setChecklistChecks, t }) {
  const handleToggle = (item) => {
    setChecklistChecks((prev) => ({ ...prev, [item]: !prev[item] }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <img
        src={key_car_checklist}
        alt="Key checklist"
        className="return-image"
      />

      <div className="cards-container">
        <div className="checklist-card">
          <span className="card-text">
            {t("keylessReturnBelongings")}
          </span>
          <label className="switch">
            <input
              type="checkbox"
              checked={checklistChecks.belongings}
              onChange={() => handleToggle("belongings")}
            />
            <span className="slider round"></span>
          </label>
        </div>

        <div className="checklist-card">
          <span className="card-text">
            {t("keylessReturnWindows")}
          </span>
          <label className="switch">
            <input
              type="checkbox"
              checked={checklistChecks.windows}
              onChange={() => handleToggle("windows")}
            />
            <span className="slider round"></span>
          </label>
        </div>

        <div className="checklist-card">
          <span className="card-text">
            {t("keylessReturnKeys")}
          </span>
          <label className="switch">
            <input
              type="checkbox"
              checked={checklistChecks.keys}
              onChange={() => handleToggle("keys")}
            />
            <span className="slider round"></span>
          </label>
        </div>

        <div className="checklist-card warning-card">
          <img src={key_error} alt="error" className="warning-icon-circle" />
          <span className="card-text">
            {t("keylessReturnCloseNotice")}
          </span>
        </div>

        <div className="checklist-card warning-card">
          <img src={key_error} alt="error" className="warning-icon-circle" />
          <span className="card-text">
            {t("keylessReturnDocsEmail")}
          </span>
        </div>
      </div>
    </div>
  );
}
